import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
export function CTASection() {
  return <section className="relative py-24 bg-gray-900 overflow-hidden" data-id="element-329" data-mp="27h5mfifcucbp">
      {/* Background patterns */}
      <div className="absolute inset-0 opacity-10" data-id="element-330" data-mp="2cef9wsj6odww">
        <div className="absolute top-0 -left-1/4 w-1/2 h-full bg-red-600 blur-[120px] rounded-full mix-blend-multiply" data-id="element-331" data-mp="2hfctn9judg0i"></div>
        <div className="absolute bottom-0 -right-1/4 w-1/2 h-full bg-red-600 blur-[120px] rounded-full mix-blend-multiply" data-id="element-332" data-mp="2md4tqqun48fs"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-333" data-mp="2qd5a4h1autph">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-334" data-mp="2v8b29xlap4m0">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6 tracking-tight" data-id="element-335" data-mp="2168c04ymp8jt">
            Ready to Get Real Results?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-336" data-mp="1w6dq6ftpn95m">
            Stop wasting budget on strategies that don't convert. Let's build a
            predictable revenue engine for your business today.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-337" data-mp="1n8jr4x4ka1er">
            <button className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-md font-bold text-lg transition-all shadow-lg hover:shadow-red-600/20 flex items-center justify-center group" data-id="element-338" data-mp="2jvybv6h90kil">
              SCHEDULE YOUR FREE SESSION
              <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-339" data-mp="2664gs6f5h40f" />
            </button>
            <span className="text-gray-400 hidden sm:inline" data-id="element-340" data-mp="32osdyztrwi5e">or</span>
            <a href="tel:17022134801" className="flex items-center text-white hover:text-red-400 transition-colors font-semibold text-lg" data-id="element-341" data-mp="2xw8ytyffteyh">
              <PhoneIcon className="w-5 h-5 mr-2" data-id="element-342" data-mp="10xs77llyt0dq" />
              (702) 213-4801
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}